import React from 'react';

import { Helmet } from 'react-helmet';
import { Redirect, useLocation } from 'react-router-dom';
import { Link } from '~/lib/react-router-dom';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '../Common/Elements/PageHeader';

import { curationTabs, curationTabsList, searchCurationTabs, searchCurationTabsList } from './ContentTabs';

interface TabConfig {
  title: string;
  component: React.ElementType;
}

export default function CurationPageContainer({
  match: {
    params: { tab },
  },
}: {
  match: {
    params: { tab: string };
  };
}) {
  const { pathname } = useLocation();
  const isSearchCurationPage = pathname.startsWith('/search-curation');
  const basePath = isSearchCurationPage ? '/search-curation' : '/curation';
  const tabs: Record<string, TabConfig> = isSearchCurationPage ? searchCurationTabs : curationTabs;
  const tabsList: Array<string> = isSearchCurationPage ? searchCurationTabsList : curationTabsList;
  const currentTab = tabs[tab];

  if (!currentTab) {
    return <Redirect to={`${basePath}/${tabsList[0]}`} />;
  }

  const index = tabsList.indexOf(tab);
  const title = `${isSearchCurationPage ? 'Search Curation' : 'Curation'} / ${currentTab.title}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container style={{ maxWidth: '95vw' }}>
        <PageHeader title={title} />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={index} variant="scrollable">
            {tabsList.map((tabKey, tabIndex) => (
              <Tab
                key={tabKey}
                value={tabIndex}
                label={tabs[tabKey].title}
                to={`${basePath}/${tabKey}`}
                component={Link}
              />
            ))}
          </Tabs>
        </Box>

        <Box mt={4}>
          <Box component={currentTab.component} />
        </Box>
      </Container>
    </>
  );
}
